// extracted by mini-css-extract-plugin
export default {"itemFeature":"ItemFeature_itemFeature__Po7ik"};